import react, { useEffect, useRef } from "react";
import { Map } from "@neshan-maps-platform/ol";
import NeshanMap from "@neshan-maps-platform/react-openlayers";
import "@neshan-maps-platform/react-openlayers/dist/style.css";
import neshan from '../assetss/img/map/neshan.png'
import balad from '../assetss/img/map/balad.png'
import google from '../assetss/img/map/google.jpg'

const Location = () => {
  // const map = new Map()
  return (
    <div className="dark:bg-gray-800 min-h-screen">
      <NeshanMap
        className=""
        mapKey="web.0b434a73505744e4a8f1993d5a0a536a"
        center={{ latitude: 35.706750671630246, longitude: 51.42581961534512 }}
        zoom={17}
        defaultType="neshan"
        style={{ height: "48vh", width: "100%" }}
        traffic={true}
        poi={true}
        // View={true}
      ></NeshanMap>
      <div className=" flex flex-col  my-4 dark:text-white ">
        <p className="dark:text-white text-center">مسیریابی با</p>
        <div className="flex justify-center gap-10 items-center mt-8">
          <a target="_blank" href="https://nshn.ir/d6rbvPWgWxi9Z4">
            <span className="flex flex-col w-16 h-16 justify-center text-center gap-2">
              <p>نشان</p>
              <img className="rounded-lg" src={neshan} alt="" />
            </span>
          </a>
          <a target="_blank" href="https://maps.app.goo.gl/zXeL1w4wxT378qELA">
          <span className="flex flex-col w-16 h-16 justify-center text-center gap-2">
              <p>گوگل</p>
              <img className="rounded-lg" src={google} alt="" />
            </span>
          </a>
          <a
            target="_blank"
            href="https://balad.ir/location?latitude=35.706654&longitude=51.425795&zoom=16.500000"
          >
            <span className="flex flex-col w-16 h-16 justify-center text-center gap-2">
              <p>بلد</p>
              <img className="rounded-lg" src={balad} alt="" />
            </span>
          </a>
        </div>
        <p className="mt-12 text-center" >آدرس : تهران خیابان مفتح جنوبی بعد از چهار خیابان طالقانی رو به روی هتل مشهد پلاک ۸۷</p>
        <p className="mt-8 text-center" >تلفن :02188862264 - 02188815696 </p>
        {/* <p className="mt-8 text-center" >ساعات کاری : 8 صبح تا  1 بامداد</p> */}
      </div>
    </div>
  );
};

export default Location;
